import Axios from 'axios'

const baseUrl = process.env.REACT_APP_URL_BACKEND;

const axiosInstance = Axios.create({
  baseURL: baseUrl
});

export default axiosInstance